export default __webpack_public_path__ + "static/media/avatar.08325774.png";